import React, { useContext, useEffect, useState } from "react";
import { Button, Drawer, message, Select } from "antd";
import "./style.css";
import alarm from "../../../Assets/Icons/alarm (1) 1.svg";
import telegram from "../../../Assets/Icons/telegram 1.svg";
import { useNavigate } from "react-router-dom";
import { getNotifications, markNotificationsAsRead } from "../../../API/User/notification";
import { UserContext } from "../../../App";
import { formatDate } from "../../../Utils/formatDate";

const { Option } = Select;

const NotificationDrawer = ({ visible, onClose }) => {
  const { userData, setUnreadNotificationCount } = useContext(UserContext);
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();

  const fetchNotifications = async () => {
    try {
      setLoading(true);

      const response = await getNotifications();

      if (Math.floor(response?.status / 100) === 2) {
        const data = response?.data?.notifications || [];
        setNotifications(data);
      } else {
        if (userData?.permissions.length > 0 && userData?.permissions.includes("monitoring")) {
          messageApi.error("Failed to fetch notifications");
        }
      }
    } catch (error) {
      if (userData?.permissions.length > 0 && userData?.permissions.includes("monitoring")) {
        messageApi.error("Error fetching notifications");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (visible) {
      fetchNotifications();
    }
  }, [visible]);

  const handleViewAll = () => {
    navigate("/notifications", { state: { notifications } });
    onClose();
  };

  const handleMarkAsread = async () => {
    const response = await markNotificationsAsRead();
    setUnreadNotificationCount(0);
    onClose();
  };

  const handleViewDetails = (id) => {
    navigate(`/view-notification-detail/${id}`);
    onClose();
  };

  return (
    <Drawer
      className="notification-drawer"
      placement="right"
      onClose={onClose}
      open={visible}
      width={332}
    >
      <div className="header">
        <div className="section-1">
          <div className="title">Notifications</div>
          <Button onClick={handleViewAll}>View All</Button>
        </div>
        <div className="mark-read" onClick={handleMarkAsread}>
          Mark all as read
        </div>
      </div>

      <div className="list-notifications">
        {notifications.map((notification) => (
          <div className="container">
            <div className="head">
              <div className="title">
                <img src={alarm} alt="Alarm" />
                {notification?.title}
              </div>
              <div className="score">{notification?.score}</div>
            </div>
            <div className="desc">{notification?.subtitle}</div>
            <div className="footer">
              <div className="status">
                {formatDate(notification?.created_at)}
              </div>
              <Button onClick={() => handleViewDetails(notification?.id)}>
                View Details
              </Button>
            </div>
          </div>
        ))}
      </div>
    </Drawer>
  );
};

export default NotificationDrawer;
